// @flow

import React from 'react'
import SvgIcon from './SvgIcon'
import LockOpenSvg from 'material-design-icons/action/svg/production/ic_lock_open_24px.svg'

// Types
type Props = {
  size?: number,
  color?: string,
  style?: Object,
}

export function LockOpen ({size = 24, color = 'rgb(0, 0, 0)', style = {}}: Props): React.Element<any> {
  return (
    <SvgIcon size={size} color={color} src={LockOpenSvg} style={style} />
  )
}

export default LockOpen
